import React from "react";
import { BrowserRouter } from "react-router-dom";
import { DeviceProvider } from "app/contexts/DeviceContext";
import { AppProvider } from "app/contexts/AppContext";
import {
  LoadingProvider,
  useLoadingContext,
} from "app/contexts/LoadingContext";
import LoadingSpinner, {
  PartialLoadingSpinner,
} from "app/components/LoadingSpinner";
import "../global-styles.css";
import AppContent from "./AppContent";

const App = () => {
  const { loadingState } = useLoadingContext();

  return (
    <>
      {/* Render different loading types */}
      {loadingState.fullPage && <LoadingSpinner type="fullPage" />}
      {loadingState.masked && <LoadingSpinner type="masked" />}

      {/* Render partial loading for each container */}
      {Object.keys(loadingState.partial).map((containerId) => (
        <PartialLoadingSpinner key={containerId} containerId={containerId} />
      ))}

      <DeviceProvider>
        <AppProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </AppProvider>
      </DeviceProvider>
    </>
  );
};

const RootApp = () => (
  <LoadingProvider>
    <App />
  </LoadingProvider>
);

export default RootApp;
